<template>

  <div class="layout-sta-atten">
    <div class="head-data-atten">
      <span class="icon-time-atten"
            @click="changeMonth(-1)"><img src="../../../assets/images/icon-last-time.png"></span>
      <span class="node-date-atten">{{pickYearMonthtxt}}</span>
      <span class="icon-time-atten"
            @click="changeMonth(1)"><img src="../../../assets/images/icon-next-time.png"></span>
    </div>
    <van-calendar title="打卡日期"
                  :poppable="false"
                  :show-confirm="false"
                  :show-subtitle="false"
                  :show-title="false"
                  :show-mark="true"
                  :default-date="calendarOpt.dateValue"
                  :min-date="calendarOpt.minDate"
                  :max-date="calendarOpt.maxDate"
                  @confirm="onCalendarConfirm"
                  :style="{ height: '9.24rem'}" />
    <div class="nav-check-list bor-top">
      <p v-show="mineStatic==SignCheckType.personal"
         @click="change(SignCheckType.personal)"
         class="ele-nav-checklist nac-nav-checklist">我的<span class="line-nav-checklist"></span></p>
      <p v-show="mineStatic==SignCheckType.personal&&userRole!=RoleType.salesman"
         @click="change(SignCheckType.branch)"
         class="ele-nav-checklist">部门</p>

      <p v-show="mineStatic==SignCheckType.branch"
         @click="change(SignCheckType.personal)"
         class="ele-nav-checklist">我的</p>
      <p v-show="mineStatic==SignCheckType.branch&&userRole!=RoleType.salesman"
         @click="change(SignCheckType.branch)"
         class="ele-nav-checklist nac-nav-checklist">部门<span class="line-nav-checklist"></span></p>

    </div>
    <div class="list-sta-info">
      <div class="ele-sta-info"
           v-for="record in records"
           :key="record.ID">
        <p class="name-clock-atten">{{record.name}}</p>
        <p><span class="color-gray">时间：</span>{{record.checkTimeTxt}}</p>
        <p><span class="color-gray">当前位置：</span>{{record.address}}</p>
        <p><span class="color-gray">经度：</span>{{record.longitude}}</p>
        <p><span class="color-gray">纬度：</span>{{record.latitude}}</p>
      </div>
    </div>
    <!--列表-->
  </div>

</template>

<script>
import checkinModel from '../../../api/model/checkin'
import { mapState } from 'vuex'
export default {
  name: 'SignCheckStatic',
  components: {},
  data() {
    return {
      mineStatic: 0,
      calendarOpt: {
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2010, 0, 31),
        dateValue: new Date(), //默认选中
      },
      records: new Array(), //记录数据
      selectDate: new Date(), //选择日期
      pickYearMonth: new Date(), //选择年月
      pickYearMonthtxt: '', //选择年月文本
    }
  },
  methods: {
    change(select) {
      this.mineStatic = select
      this.getRecords()
    },
    changeMonth(num) {
      const pickYear = this.pickYearMonth.getFullYear()
      const pickmonth = this.pickYearMonth.getMonth()
      this.pickYearMonth = new Date(pickYear, pickmonth + num, 1)
      this.pickYearMonthtxt = `${this.pickYearMonth.getFullYear()}-${
        this.pickYearMonth.getMonth() + 1
      }`
      this.setCalendar(
        this.pickYearMonth.getMonth(),
        this.pickYearMonth.getFullYear()
      )
    },
    initCalendar() {
      const now = new Date()
      const month = now.getMonth()
      const year = now.getFullYear()
      this.setCalendar(month, year)
      this.pickYearMonthtxt = `${this.pickYearMonth.getFullYear()}-${
        this.pickYearMonth.getMonth() + 1
      }`
    },
    setCalendar(month, year) {
      this.calendarOpt.minDate = new Date(year, month, 1)
      this.calendarOpt.maxDate = new Date(year, month + 1, 0)
    },
    formatCalendarDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onCalendarConfirm(date) {
      this.calendarShow = false
      this.dateValue = date
      this.selectDate = this.formatCalendarDate(date)
      this.getRecords()
    },
    async getRecords() {
      const res = await checkinModel.getSignCheckRecords({
        date: this.selectDate,
        type: this.mineStatic,
      })
      if (res.success) {
        this.records = res.data
      } else {
        this.$toast(res.msg)
      }
    },
  },
  computed: {
    ...mapState('systemAbout', ['SignCheckType', 'RoleType']),
    ...mapState('userAbout', ['userRole']),
  },
  mounted() {
    this.initCalendar()
    this.getRecords()
  },
}
</script>

<style scoped>
</style>
